// A frame navigation whose response carries no matching turbo-frame lands the
// user on a card that reads "Content missing" while the rest of the page keeps
// pretending nothing happened. The response is almost never garbage — it is a
// whole page the browser should simply have gone to: an expired session
// redirecting to the sign-in screen, or a preference changed in another tab
// that made this frame disappear from the layout.
//
// Turning it into a full visit is Turbo's documented escape hatch, and it
// restores what a plain non-Turbo form submit used to do. Registered once for
// every frame in the app rather than per component, so no control can opt out
// of it by accident.
export function visitWhenFrameIsMissing() {
  document.addEventListener("turbo:frame-missing", (event) => {
    const { response, visit } = event.detail

    event.preventDefault()
    visit(response)
  })
}
